import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChooseNumbers = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.372 4.648a5.9 5.9 0 0 1 7.451 9.076.75.75 0 1 0 1.061 1.06 7.4 7.4 0 1 0-10.469 0 .75.75 0 0 0 1.061-1.06 5.9 5.9 0 0 1 .896-9.076m1.51 7.335a2.5 2.5 0 0 1 1.616-.728v-4.13c-.576.38-1.605.698-2.5.845l-.22-1.041c1.14-.196 2.389-.674 3.014-1.348h1.078v5.987a2.5 2.5 0 0 1 1.28 2.183v3.1h2.05a3.55 3.55 0 0 1 3.55 3.55v.7a.75.75 0 0 1-1.5 0v-.7a2.05 2.05 0 0 0-2.05-2.05h-2.8a.75.75 0 0 1-.75-.75v-3.85a1 1 0 0 0-2 0v7.35a.75.75 0 0 1-1.5 0v-7.35a2.5 2.5 0 0 1 .732-1.768"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChooseNumbers;
